<template>
    <div></div>
</template>

<script>
import axios from 'axios'
export default {
    name: `SSOLogin`,
    data() {
        return {
            title: ``
        }
    },
    mounted() {
        this.ssologin()
    },
    computed: {
        // ...mapGetters(["departments","hospitals","dept","accessDept"]),
        clientName() {
            //  return this.hospitals&&this.hospitals.length>0 ?this.hospitals[0].label:"--"
            return this.$root.HospitalName || ``
        }
    },
    methods: {
        getToken() {
            let req = axios.get(`${this.$root.DOCSERVICE_BASE}/Wth/GetAuthToken`, {
                headers: { 'content-type': `application/x-www-form-urlencoded` }
            })
            req.then(res => {
                console.log(`11111111111111111111111`, res)
                if (res != null && res.Status === `SUCCESS`) {
                    sessionStorage.setItem(`doctoken`, res.Content)
                }
            }).catch(err => {
                console.log(err)
            })
        },
        ssologin(token) {
            let query = this.$route.query
            console.log(query)
            let querystring = ``
            _.each(query, (value, key) => {
                querystring += key + `=` + value + `&`
            })
            if (querystring == ``) {
                this.$message.error(`url参数不允许为空！`)
                return
            }
            querystring = querystring.trim(`&`)
            this.myaxios
                .post(`api/AcisSystem/Authorization/GetSSOToken`, {
                    user_agent: `chrome`,
                    timestamp: new Date().getTime(),
                    data: querystring
                })
                .then(data => {
                    if (data && data.transUrl) {
                        window.location.href = data.transUrl
                    } else if (data && data.token) {
                        let datatoken = data.token
                        // 启用单点登录开启了CA场景
                        let useCa = this.$root.useCa == `1`
                        if (useCa) {
                            // 调动ca登录生成catoken
                            let r = this.$root.CaValidTokenUrl.replace(`GetUserInfo`, `AppLogin`)
                            console.log(r)
                            this.myaxios.post(`${r}?app_key=${this.$root.appKey}&sys_ca_config_id=0`, {
                                user_agent: `chrome`,
                                timestamp: new Date().getTime(),
                                data: {
                                    uid: data.userName,
                                    cert_signature: null
                                }
                            }).then(catoken => {
                                // 拿到catoken，把catoken给到手麻
                                if (catoken) {
                                    let caUrl = `api/AcisSystem/Authorization/ChangeToken?caToken=${catoken}`
                                    this.myaxios
                                        .get(caUrl)
                                        .then(f => {
                                            this.getToken()
                                            this.ssologinredirect(datatoken, catoken)
                                        })
                                } else {
                                    this.ssologinredirect(datatoken, null)
                                }
                            }).catch(e => {
                                this.$alert(`未绑定，将跳转到绑定页面！`, `错误`, {
                                    confirmButtonText: `确定`,
                                    type: `error`
                                }).then(this.gotoCaLogin)
                            })
                        } else {
                            this.ssologinredirect(datatoken, null)
                        }
                    }
                })
        },
        gotoCaLogin() {
            this.$store.dispatch(`Get_Menu`).then((menus) => {
                console.log(menus)
                if (menus.findIndex(item => item.code === `6298723fae9d12ba9730c36787e868e8`) == -1) {
                    this.$alert(`CA未授权，无法使用CA功能`, `提醒`, {
                        dangerouslyUseHTMLString: true,
                        type: `warning`
                    })
                } else {
                    let redirect = this.$route.query.redirect
                    if (!redirect || redirect == `undefined`) redirect = ``
                    window.location.href = `${this.$root.CaLoginUrl}?app_key=${this.$root.appKey}&redirect=${redirect}`
                }
            })
        },
        ssologinredirect(token, catoken) {
            sessionStorage.setItem(`token`, token)
            if (catoken) {
                sessionStorage.setItem(`caToken`, catoken)
            }
            this.$store.dispatch(`ADD_OtherSettingColumn`)
            this.$store.dispatch(`ADD_ExtendColumnList`)
            let r = typeof winformMsg
            if (r != `undefined`) {
                var cefJson = {
                    action: `login`,
                    token: token,
                    caToken: catoken
                }
                winformMsg.acceptMessage(cefJson)
            }
            let redirect = this.$route.query.redirect
            if (redirect && redirect != `/`) {
                this.$router.push({ path: redirect }).catch(err => err)
            } else {
                this.$router.push({ path: `/` }).catch(err => err)
            }
        }
    }
}
</script>

<style scoped>
.first-page .el-header {
    background: black;
    color: whitesmoke;
    height: 30px !important;
}

.login_page {
    color: white;
    width: 100%;
    height: 100%;
    background-image: url('../assets/bg.jpg');
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.login_page .half-opacity {
    color: rgba(255, 255, 255, 0.5);
}

.login_div {
    left: 50%;
    margin-left: -512px;
    top: 50%;
    margin-top: -260px;
    display: inline-block;
    position: fixed;
    background-repeat: no-repeat;
}

.login_div .el-row {
    padding-top: 20px;
}
.login_image {
    width: 640px;
    height: 480px;
    position: relative;
    border-radius: 15px 0 0 15px;
    background-image: url('../assets/anesthesia.jpg');
    background-repeat: no-repeat;
    background-position-x: -85px;
}

.product_slogon {
    padding: 20px;
    position: absolute;
    bottom: 20px;
    left: 20px;
    display: inline-block;
    background-color: rgba(0, 0, 0, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/SSOLogin.vue